import { render, staticRenderFns } from "./SucessoModal.vue?vue&type=template&id=46ac3ab5"
import script from "./SucessoModal.vue?vue&type=script&lang=js"
export * from "./SucessoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports